<div
  class="modal"
  [class.show-push-options]="!selectedPrimaryPushType"
  [class.duplicate-push-tall]="selectedPrimaryPushType === 'Duplicate and Push'"
>
  <div class="title-row">
    <div class="title">
      <mat-icon fontSet="material-icons-round" class="icon">send</mat-icon>
      <div class="title-text">
        <span class="kbody-huge">Push Course</span>
        <span
          class="klabel-medium source-subtitle"
          *ngIf="selectedPrimaryPushType === 'Duplicate and Push' && completeCourseSessionDetails?.Course?.courseName"
        >Source: {{ completeCourseSessionDetails?.Course?.courseName }}</span>
      </div>
    </div>
    <mat-icon
      fontSet="material-icons-round"
      class="close"
      (click)="closeModal()"
      >close</mat-icon
    >
  </div>
  <div class="content">
    <div class="primary-push-options" *ngIf="!selectedPrimaryPushType">
      <span class="klabel-huge push-type-label">Choose push type:</span>
      <div
        class="option-row"
        (click)="selectedPrimaryPushType = 'Push to Group'"
        *ngIf="user.Roles[0].accessLevel === 'MANAGE_ALL_AUTHORITY'"
      >
        <mat-icon fontSet="material-icons-outlined" class="icon"
          >groups</mat-icon
        >
        <span class="ksubtitle-medium">Push to Group</span>
      </div>
      <!-- TODO - cleanup - uncomment as functionality is released -->
      <!-- <div class="option-row">
        <span class="ksubtitle-huge">Push to all staff I manage</span>
        <mat-icon fontSet="material-icons-round" class="icon">chevron_right</mat-icon>
      </div> -->
      <!-- <div class="option-row">
        <span class="ksubtitle-huge">Push to Individual People</span>
        <mat-icon fontSet="material-icons-round" class="icon">chevron_right</mat-icon>
      </div> -->
      <div class="option-row" (click)="selectedPrimaryPushType = 'Quick People Push'">
        <mat-icon fontSet="material-icons-outlined" class="icon">person</mat-icon>
        <span class="ksubtitle-medium">Quick People Push</span>
      </div>
      <div
        class="option-row"
        *ngIf="showDuplicateAndPush()"
        (click)="selectedPrimaryPushType = 'Duplicate and Push'"
      >
        <mat-icon fontSet="material-icons-outlined" class="icon">content_copy</mat-icon>
        <span class="ksubtitle-medium">Duplicate &amp; Push</span>
      </div>
      <!-- <div class="option-row" *ngIf="permissions.COURSE_ADD">
        <span class="ksubtitle-huge">Copy and Push</span>
        <mat-icon fontSet="material-icons-round" class="icon">chevron_right</mat-icon>
      </div> -->
      <!-- <div class="option-row">
        <span class="ksubtitle-huge">Upload Spreadsheet</span>
        <mat-icon fontSet="material-icons-round" class="icon">chevron_right</mat-icon>
      </div> -->
    </div>

    <!-- this is where all the primary push options will go -->
    <app-push-to-group
      [completeCourseSessionDetails]="completeCourseSessionDetails"
      (backToPrimaryPushList)="selectedPrimaryPushType = null"
      class="component"
      *ngIf="selectedPrimaryPushType === 'Push to Group'"
    ></app-push-to-group>

    <app-quick-people-push
      [completeCourseSessionDetails]="completeCourseSessionDetails"
      (backToPrimaryPushList)="selectedPrimaryPushType = null"
      class="component"
      *ngIf="selectedPrimaryPushType === 'Quick People Push'"
    ></app-quick-people-push>

    <app-duplicate-and-push
      [completeCourseSessionDetails]="completeCourseSessionDetails"
      (backToPrimaryPushList)="selectedPrimaryPushType = null"
      class="component"
      *ngIf="selectedPrimaryPushType === 'Duplicate and Push'"
    ></app-duplicate-and-push>

    <div *ngIf="!selectedPrimaryPushType" class="nav-row">
      <div class="left-nav">
        <app-button
          (click)="closeModal()"
          [text]="'Back to course details'"
          [class]="'white'"
          [icon]="{ materialIcon: 'arrow_back' }"
        ></app-button>
      </div>
      <app-button
        (click)="closeModal()"
        [text]="'Exit Window'"
        [class]="'white'"
      ></app-button>
    </div>
  </div>
</div>
